import { useLocation } from 'react-router-dom';

/**
 * The catalog is mounted twice in `App.tsx` — once in the brand shell at
 * `/catalog/*` and once in the admin shell at `/admin/catalog/*` (Ari,
 * 2026-09-10: clicking Catalog from the admin sidebar must not swap the whole
 * shell). Every in-catalog link derives its prefix from here so the two
 * mounts share one set of screens. Same rule as `portalBasePath` in
 * `Sidebar.tsx`.
 */
export const CATALOG_BASE = '/catalog';
export const ADMIN_CATALOG_BASE = '/admin/catalog';

export function catalogBasePath(pathname: string): string {
  return pathname === '/admin' || pathname.startsWith('/admin/') ? ADMIN_CATALOG_BASE : CATALOG_BASE;
}

export function useCatalogBasePath(): string {
  const { pathname } = useLocation();
  return catalogBasePath(pathname);
}

/** A brand-shell catalog URL rewritten to its admin twin; admin URLs pass through. */
export function adminCatalogPath(pathname: string, search: string): string {
  return pathname.replace(/^\/catalog(?=\/|$)/, ADMIN_CATALOG_BASE) + search;
}
